import { Dropdown } from "@fanduel/og-fe-library";
import { useEffect, useState } from "react";
import { viewOptions } from "@/constants/horseRacing";

const options = [
  { label: viewOptions.ALL },
  { label: viewOptions.US },
  { label: viewOptions.INTERNATIONAL },
];

interface ViewControlProps {
  setView: (input: string) => void;
}
const ViewControl = ({ setView }: ViewControlProps) => {
  const [selected, setSelected] = useState(0);
  useEffect(() => {
    setView(options[selected].label);
  }, [selected, setView]);
  return (
    <div>
      <Dropdown
        variant="standard"
        selected={selected}
        setSelected={setSelected}
        options={options}
        title="View"
      />
    </div>
  );
};

export default ViewControl;
